import { useMutation } from "@apollo/client";
import { TOGGLE_INCLUDE_IN_PROPOSAL } from "~/graphql/mutation/toggle-parent-phase-output";
import { FIND_MATTER } from "~/graphql/query";
import { UPDATE_PARENT_MATTER } from "../order-parents-hook";
import { FIND_PARENT_MATTER_QUERY } from "../parent-matter-query";

export const useToggleIncludeProposal = () => {
  const [updateFunc] = useMutation(TOGGLE_INCLUDE_IN_PROPOSAL);

  return (newValue: boolean, id: number) =>
    updateFunc({
      variables: { toggleIncludeInProposalId: id, include: newValue },
      update: (cache, { data }) => {
        if (data?.toggleIncludeInProposal) {
          cache.updateQuery(
            {
              query: FIND_PARENT_MATTER_QUERY,
              variables: { id },
            },
            (currentData) => {
              if (!currentData?.findParentMatter) return;

              const newPhases = currentData.findParentMatter.phases.map((phase) => {
                if (phase?.id === data.toggleIncludeInProposal?.id) {
                  return {
                    ...phase,
                    includeInProposalOutput: data.toggleIncludeInProposal.includeInProposalOutput,
                  };
                }
                return phase;
              });

              return {
                findParentMatter: {
                  ...currentData.findParentMatter,
                  phases: newPhases,
                },
              };
            }
          );
        }
      },
    });
};

export function useUpdateParentMatter(parentMatterIdParsed: number) {
  return useMutation(UPDATE_PARENT_MATTER, {
    update: (cache, { data }, { variables }) => {
      cache.updateQuery(
        {
          query: FIND_PARENT_MATTER_QUERY,
          variables: { id: parentMatterIdParsed },
        },
        (currentData) => {
          if (!currentData?.findParentMatter) return;

          return {
            findParentMatter: {
              ...currentData.findParentMatter,
              client: {
                ...currentData.findParentMatter.client,
                ...data?.updateParentMatter.client,
              },
            },
          };
        }
      );

      if (variables?.updateInput.client?.connect?.id || variables?.updateInput.client?.disconnect) {
        data?.updateParentMatter.matters.forEach(({ id }) => {
          cache.updateQuery(
            {
              query: FIND_MATTER,
              variables: { id },
            },
            (currentData) => {
              if (!currentData) return;

              return {
                findMatter: {
                  ...currentData.findMatter,
                  client: {
                    ...currentData.findMatter.client,
                    ...data?.updateParentMatter.client,
                  },
                  externalMatter: null,
                  externalMatterId: null,
                },
              };
            }
          );
        });
      }
    },
  });
}
